import { Link } from "gatsby";
import React from "react";
import moment from "moment";

import styled from "styled-components";
import { media } from "./_includes/Device";

import { sortArray } from "../utils/utils";

const Section = styled.div`
  &.bg-green {
    > *:before {
      height: 100%;
    }

    * {
      color: white;
    }

    .date:after {
      background-color: white;
    }
  }
`;

const Container = styled.div`
  padding: 90px 20px;
  margin: 0 auto;
  max-width: 1200px;
  position: relative;

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid #e5e5e5;
    overflow: hidden;
    transition: padding 0.2s ease-in-out;

    &:hover,
    &:focus {
      padding-left: 20px;

      p {
        color: #e1171e;

        &:first-child {
          margin-left: 44px;
        }
      }
    }

    a {
      display: flex;
      padding: 20px 0;
      align-items: center;
      justify-content: space-between;
    }

    &:first-child {
      padding-top: 0;
    }
  }

  ${media.tablet`
    display: block;
    padding: 70px 20px;
    
    li {
      &:hover,
      &:focus {
        padding-left: 0;
        
        p {
          color: #999;
  
          &:first-child {
            margin-left: 0px;
          }
        }
      }
    }
    
    ul li a {
      flex-wrap: wrap;
    
      span {
        width: 75%;
        max-width: 75%;
        flex-basis: 75%;
        
        &:first-child {
          width: 20%;
          max-width: 20%;
          flex-basis: 20%;
        }
      }
    }
    
  `};
`;

const Date = styled.span`
  font-weight: 600;
  padding-right: 25px;
  margin-right: 10px;
  position: relative;
  text-transform: lowercase;
  flex-shrink: 0;

  &:after {
    content: "";
    background-color: black;
    height: 2px;
    width: 15px;
    vertical-align: middle;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  ${media.tablet`
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  `}
`;

const City = styled.span`
  color: #999;
  margin-left: auto;
`;

export class EventsList extends React.Component {
  render() {
    sortArray(this.props.events, "metadata.primary");

    return (
      <Section className={this.props.componentClass}>
        <Container>
          <ul>
            {this.props.events &&
              this.props.events.map(event => {
                let formattedDate = moment(event.metadata.primary).format(
                  "DD MMM"
                );

                return (
                  <li key={event.id}>
                    <Link to={event.link + "-" + event.id}>
                      <Date className={"date"}>{formattedDate}</Date>
                      <span>{event.title}</span>
                      <City>{event.metadata.secondary}</City>
                    </Link>
                  </li>
                );
              })}
          </ul>
        </Container>
      </Section>
    );
  }
}
